import template from './alternate-brands.html';
import './alternate-brands.global.css';

export const AlternateBrandsComponent = {
  template,
  transclude: true,
};
